import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { SharedServiceService } from 'app/services/shared-service.service';
@Component({
  selector: 'app-mobile-input',
  templateUrl: './mobile-input.component.html',
  styleUrls: ['./mobile-input.component.scss']
})
export class MobileInputComponent implements OnChanges {
  @Input() mobileNumber = '';
  errorMsg = '';
  @Input() OperErrMsg = '';
  @Input() isEmpty = false;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @Output() checkOperator: EventEmitter<any> = new EventEmitter();
  constructor(private sharedService: SharedServiceService) { }

  ngOnChanges(): void {
    if (this.isEmpty) {
      this.errorMsg = 'پر کردن این فیلد الزامی است.';
    }
  }
  checkMobilePattern() {
    this.errorMsg = '';
    this.mobileNumber = this.sharedService.convertToEnglishNumber(this.mobileNumber);
    if (this.mobileNumber === '') {
      this.errorMsg = 'پر کردن این فیلد الزامی است.';
    } else if (this.mobileNumber[0] !== '0') {
      this.errorMsg = 'شماره موبایل نامعتبر است.';
    } else if (this.mobileNumber.length > 1 && this.mobileNumber[1] !== '9') {
      this.errorMsg = 'شماره موبایل نامعتبر است.';
    } else if (this.mobileNumber.length === 3) {
      this.checkOperator.emit(this.mobileNumber.substr(0, 3));
    }
    if (this.mobileNumber.length === 11) {
      const patt = /^(09)?[0-9]{9}$/;
      const res = patt.test(this.mobileNumber);
      if (!res) {
        this.errorMsg = 'شماره موبایل نامعتبر است.';
      }
      if (this.errorMsg === '') {
        this.notifyParent.emit(this.mobileNumber);
      }
    }
  }
  emitValue() {
    this.checkMobilePattern();
    const patt = /(\+98|0)?9\d{9}/; // /^(09)?[0-9]{9}$/;
    const res = patt.test(this.mobileNumber);
    if (!res) {
      this.errorMsg = 'شماره موبایل نامعتبر است.';
    }
    if (this.errorMsg === '') {
      this.notifyParent.emit(this.mobileNumber);
    }
  }
}
